import React from 'react';

import { alpha } from '@mui/material/styles';

import styled, { CssUtilityType } from '../../../styled';
import { colorsPalette } from '../../../theme';
import { useTooltipOffset } from '../../../utils/hooks';
import { LightTooltip } from '../LightTooltip';

interface ProgressLineProps {
  width?: number;
  className?: string;
  lineCss?: CssUtilityType;
  tooltipText?: string;
}

const ProgressLine: React.FC<ProgressLineProps> = ({
  width = 0,
  className = '',
  lineCss = '',
  tooltipText = '',
}) => {
  const [offset, wrapperRef, handleMouseEnter] = useTooltipOffset();

  return tooltipText ? (
    <StyledTooltip
      placement="top"
      title={tooltipText}
      PopperProps={{
        popperOptions: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [offset.x, 0],
              },
            },
          ],
        },
      }}
    >
      <Wrapper ref={wrapperRef} onMouseEnter={handleMouseEnter} className={className}>
        <Line data-testid="progress" style={{ width: `${width}%` }} additionalStyles={lineCss} />
      </Wrapper>
    </StyledTooltip>
  ) : (
    <Wrapper className={className}>
      <Line data-testid="progress" style={{ width: `${width}%` }} additionalStyles={lineCss} />
    </Wrapper>
  );
};

export default ProgressLine;

const StyledTooltip = styled(LightTooltip)`
  &:before {
    display: none;
  }
`;
const Wrapper = styled('div')`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 6px;
  background: ${alpha(colorsPalette.white, 0.07)};
  width: 100%;
  z-index: 5;
`;
const Line = styled('div', {
  shouldForwardProp: (prop) => prop !== 'additionalStyles',
})`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%;
  transition: width 0.5s;
  background: ${colorsPalette.blueProgressBar};
  z-index: 6;

  ${({ additionalStyles }) => additionalStyles}
`;
